export default "__VITE_ASSET__1a7c3335__"